import React from 'react';

import ClosedMenuIcon from '../icons/ClosedMenuIcon';
import Delayed from './Delayed';

import { AnimatedGradientBox } from './styles';

export type ClosedMenuProps = {
    handleOpen: any;
    shouldAnimate: boolean;
};

const ClosedMenu = ({ handleOpen, shouldAnimate }: ClosedMenuProps) => {
    return (
        <Delayed waitBeforeShow={100}>
            <div onClick={handleOpen}>
                <AnimatedGradientBox className="navigation-global-wrapper">
                    <ClosedMenuIcon fill="#fff" />
                </AnimatedGradientBox>
            </div>
        </Delayed>
    );
};

export default ClosedMenu;
